import Button from '@material-ui/core/Button';
import Fade from '@material-ui/core/Fade';
import Grid from '@material-ui/core/Grid';
import Icon from '@material-ui/core/Icon';
import type { StyledComponentProps } from '@material-ui/core/styles';
import { MuiThemeProvider } from '@material-ui/core/styles';
import TextField from '@material-ui/core/TextField';
import Spin from 'components/Spin';
import { theme } from 'components/Theme';
import Truncate from 'components/Truncate';
import isEqual from 'lodash/isEqual';
import moment from 'moment';
import { parse } from 'query-string';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { toast } from 'react-toastify';
import { getChats, getMessagesChat, sendMessageBroadcast } from 'store/Orbita/MessagingInternal/actions';
import PermissionHide from 'v2/components/Shared/PermissionHide';

import Chat from './components/Chat';
import New from './components/New';
import styles from './styles/';

import type { DispatchProp } from 'react-redux';

interface IProps extends DispatchProp<any>, StyledComponentProps {
  chats: any;
  chatSelected: any;
  match: any;
  location: any;
  history: any;
  broadcastId: any;
}

interface IStates {
  search: string;
  valueAnswer: string;
  loading: boolean;
  loadingChat: boolean;
  data: any;
  acceptsData: any;
  chatData: any;
  sendEmail: boolean;
  messageSelected: number;
  modalNew: boolean;
  isUpdateMessages: boolean;
}

class Messages extends Component<IProps, IStates> {
  messagesEnd = React.createRef() as any;

  constructor(props: IProps) {
    super(props);

    this.state = {
      search: '',
      valueAnswer: '',
      loading: true,
      loadingChat: true,
      data: [],
      acceptsData: [],
      chatData: [],
      sendEmail: false,
      messageSelected: 0,
      modalNew: false,
      isUpdateMessages: false,
    };
  }

  handleSearch = (event: any) => {
    this.setState({ search: event.target.value }, () => {
      let filter = this.state.search.toLowerCase();
      let elements: any = document.getElementsByClassName('--search-chat');

      for (let i = 0; i < elements.length; i++) {
        if (elements[i].innerText.toLowerCase().includes(filter)) {
          elements[i].style.display = 'flex';
        } else {
          elements[i].style.display = 'none';
        }
      }
    });
  };

  resetSearch = () => {
    this.setState({ search: '' }, () => {
      let elements: any = document.getElementsByClassName('--search-chat');

      for (let i = 0; i < elements.length; i++) {
        elements[i].style.display = 'flex';
      }
    });
  };

  getChats = () => {
    (async () => {
      try {
        this.setState({ loading: true });
        await this.props.dispatch(getChats());
        const data = this.props.chats?.data?.chats || [];
        this.setState({ loading: false, data });
      } catch (error) {
        toast.error('Ocorreu um erro ao tentar carregar mensagens');
      }
    })();
  };

  checkNewMessages = () => {
    (async () => {
      await this.props.dispatch(getChats());

      const data = this.props.chats?.data?.chats || [];

      if (!isEqual(data, this.state.data)) {
        this.setState({ data });
      }
    })();
  };

  handleSelectMessage = async (id: number) => {
    if (id !== this.state.messageSelected) {
      this.setState({ loadingChat: true });

      try {
        this.setState({ messageSelected: id });
        this.resetSearch();

        await this.props.dispatch(getMessagesChat(id));

        this.setState({ loadingChat: false, chatData: this.props.chatSelected.data }, () => {
          this.checkNewMessages();
          this.scrollToBottom();
        });
      } catch (error) {
        this.setState({ loadingChat: false });
        toast.error('Ocorreu um erro ao tentar carregar mensagens');
      }
    }
  };

  handleSelectChatWithAffiliate = async (id: any) => {
    await this.props.dispatch(sendMessageBroadcast('', [id], false));
    const chatId = this.props.broadcastId;
    if (chatId) return this.handleSelectMessage(chatId);
    toast.error('Erro ao carregar conversa com afiliado');
  };

  updateChat = () => {
    (async () => {
      try {
        this.setState({ isUpdateMessages: true });
        await this.props.dispatch(getMessagesChat(this.state.messageSelected));
        this.setState({ chatData: this.props.chatSelected.data, isUpdateMessages: false });
      } catch (error) {
        this.setState({ isUpdateMessages: false });
      }
    })();
  };

  toggleModalNew = () => {
    this.setState({ modalNew: !this.state.modalNew });
  };

  scrollToBottom = () => {
    const element = document.getElementById('chat-content');
    element.scrollTop = element.scrollHeight;
  };

  async componentDidMount() {
    window['interval'] = setInterval(() => {
      this.checkNewMessages();
    }, 10000 * 3);

    const params = this.props.match.params;
    const queryParams = parse(this.props.location.search);

    (async () => {
      try {
        this.setState({ loading: true });
        await this.props.dispatch(getChats());

        let accepts = [] as any;
        const response = this.props.chats?.data?.chats || [];

        response.map((chat: any) => accepts.push(chat.id));

        this.setState({ loading: false, data: response, acceptsData: accepts }, () => {
          if (!queryParams.affiliate && !params.id && !accepts.includes(parseInt(params.id))) {
            this.setState({ loadingChat: false });
          }

          if (params.id && accepts.includes(parseInt(params.id))) {
            this.handleSelectMessage(params.id);
          }

          if (!params.id && queryParams.affiliate) {
            this.handleSelectChatWithAffiliate(queryParams.affiliate);
          }
        });
      } catch (error) {
        this.setState({ loading: false });
        toast.error('Ocorreu um erro ao tentar carregar mensagens');
      }
    })();
  }

  componentWillUnmount() {
    window.clearInterval(window['interval']);
  }

  render() {
    const { classes } = this.props;
    const { search, loading, loadingChat, data, chatData, messageSelected, modalNew, isUpdateMessages } = this.state;

    return (
      <MuiThemeProvider theme={theme}>
        <Fade in={true} timeout={500}>
          <div className={classes.messages}>
            <Grid container spacing={2}>
              <Grid item xs={12} md={4}>
                <div className={classes.chatList}>
                  <div className={classes.chatHead}>
                    <div>Conversas</div>
                    <PermissionHide action={'myeduzz:meus-afiliados:editar'}>
                      <Button variant='contained' color='secondary' size='small' onClick={() => this.toggleModalNew()}>
                        <Icon style={{ fontSize: 20, marginRight: 4 }}>add</Icon> Nova
                      </Button>
                    </PermissionHide>
                  </div>

                  <div className='m16'></div>

                  <div className={classes.chatSearch}>
                    <TextField placeholder='Buscar' id='search-box' fullWidth value={search} onChange={this.handleSearch} disabled={loading} />
                  </div>

                  <div className='m16'></div>

                  <div className={classes.chatContent}>
                    {loading && (
                      <div className={classes.loading}>
                        <Spin />
                      </div>
                    )}

                    {!loading && data && data.length === 0 && <div className={classes.chatEmpty}>Nenhuma conversa encontrada.</div>}

                    {!loading &&
                      data &&
                      data.length > 0 &&
                      data.map((chat: any, index: any) => {
                        return (
                          <div
                            key={'chat-' + index}
                            className={`${classes.chatItem} ${chat.not_read_count > 0 ? '--not-read' : ''} --search-chat ${
                              messageSelected == chat.id ? '--selected' : ''
                            }`}
                            onClick={() => this.handleSelectMessage(chat.id)}
                          >
                            <div
                              className={`${classes.chatImage} ${chat.not_read_count > 0 ? '--not-read' : ''}`}
                              style={{
                                backgroundImage: `url(${chat.outer.avatar ? chat.outer.avatar : '/img/avatar-default.png'})`,
                              }}
                            >
                              <span></span>
                              <div
                                className={`${classes.badgeAvatar} ${chat.outer.qualification ? '--hasBadge' : ''}`}
                                style={{
                                  backgroundImage: `url(${
                                    chat.outer.qualification
                                      ? `/img/badges/${chat.outer.qualification.badge_elite}` +
                                        (chat.outer.qualification.has_plus ? '-plus' : '') +
                                        '.svg'
                                      : ''
                                  })`,
                                }}
                              ></div>
                            </div>
                            <div className={classes.chatMessage}>
                              <div className={classes.chatTitle}>
                                <Truncate count={25} final='...'>
                                  {chat.outer.name}
                                </Truncate>
                              </div>
                              <div className={classes.chatText}>
                                <Truncate count={28} final='...'>
                                  {chat.last.content}
                                </Truncate>
                              </div>
                              <div className={classes.chatDate}>{chat.last.created_at && moment(chat.last.created_at).format('DD/MM/YYYY H:mm')}</div>
                            </div>
                          </div>
                        );
                      })}
                  </div>
                </div>
              </Grid>

              <Grid item xs={12} md={8}>
                <Chat
                  loading={loadingChat}
                  messageSelected={messageSelected}
                  chat={chatData}
                  updateChat={this.updateChat}
                  isUpdateMessages={isUpdateMessages}
                />
              </Grid>
            </Grid>

            <New active={modalNew} updateChats={this.checkNewMessages} closeModal={this.toggleModalNew} />
          </div>
        </Fade>
      </MuiThemeProvider>
    );
  }
}

function mapStateToProps(state: any) {
  return {
    chats: state.orbita.Messages.getChats,
    chatSelected: state.orbita.Messages.getMessagesChat,
    broadcastId: state.orbita.Messages.sendMessageBroadcast,
  };
}

export default connect(mapStateToProps)(styles(Messages));
